'use client'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { SeoHeadDescriptionMetas, SeoHeadTitleMetas } from '../../seo'

export const MarketplacePartnerRegisterPageMetas: FC = () => {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'marketplacePartnerRegisterPage.meta.title',
  })
  const description = intl.formatMessage({
    id: 'marketplacePartnerRegisterPage.meta.description',
  })

  return (
    <>
      <SeoHeadTitleMetas title={title} />
      <SeoHeadDescriptionMetas description={description} />
    </>
  )
}
